//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import inschrijven from '~/graphql/mutations/inschrijven.gql';
import page from '~/plugins/mixins/page';

export default {
  auth: false,
  mixins: [page],
  data: () => ({
    formData: {},
    step: 0,
    error: null,
    idealLink: null,
    maatwerkroute: false,
    done: false,
  }),
  methods: {
    gotoTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    previous() {
      if (this.step > 0) {
        this.step--;
        this.gotoTop();
      }
    },
    next() {
      if (++this.step <= 4) {
        this.gotoTop();
      } else {
        this.sendData();
      }
    },
    submit() {
      this.next();
    },
    getKey(key, required = false) {
      /** @var {string[]} */
      const parts = key.split('.');
      let value = this.formData;
      while (parts.length > 0) {
        const part = parts.shift();
        if (typeof value[part] === 'undefined') {
          if (required) {
            throw new Error(`required ${key} is missing`);
          } else {
            return null;
          }
        }
        value = value[part];
      }
      return value;
    },
    setFormData(data) {
      this.formData = data;
    },
    setPraktijkGegevens(i, data) {
      this.formData.praktijkgegevens[i] = data;
    },
    checkOptionalInt(key, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
      const value = this.getKey(key);
      switch (typeof value) {
        case 'number':
          if (Number.isInteger(value)) {
            if (value < min) {
              throw new Error(`expected ${key} to be at least ${min}, but found ${value}`);
            }
            if (value > max) {
              throw new Error(`expected ${key} to be at most ${max}, but found ${value}`);
            }
            return value;
          } else {
            throw new TypeError(`expected ${key} to be an integer, but found float`);
          }
        case 'string':
          if (value.length < 1) {
            return null;
          } else if (/^\d+$/.test(value)) {
            const number = Number.parseInt(value, 10);
            if (number < min) {
              throw new Error(`expected ${key} to be at least ${min}, but found ${number}`);
            }
            if (number > max) {
              throw new Error(`expected ${key} to be at most ${max}, but found ${number}`);
            }
            return number;
          } else {
            throw new TypeError(`expected ${key} to be an integer, but found string`);
          }
        case 'object':
          if (value === null) {
            return null;
          }
        // eslint-disable-next-line no-fallthrough
        default:
          throw new TypeError(`expected ${key} to be a string, but found ${typeof value}`);
      }
    },
    checkRequiredInt(key, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
      const value = this.checkOptionalInt(key, min, max);
      if (value === null) {
        throw new Error(`required ${key} is missing`);
      }
      return value;
    },
    checkOptionalString(key) {
      const value = this.getKey(key);
      switch (typeof value) {
        case 'string':
          return value.length ? value : null;
        case 'undefined':
          return null;
        case 'object':
          if (value === null) {
            return null;
          }
        // eslint-disable-next-line no-fallthrough
        default:
          throw new TypeError(`expected ${key} to be a string, but found ${typeof value}`);
      }
    },
    checkRequiredString(key) {
      const value = this.checkOptionalString(key);
      if (!value) {
        throw new Error(`required ${key} is missing`);
      }
      return value;
    },
    checkRequiredDate(key) {
      const value = this.checkRequiredString(key);
      if (!/^\d{4}-((0[1-9])|(1[0-2]))-((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(value)) {
        throw new TypeError(`expected ${key} to be a date, but found ${value}`);
      }
      return value;
    },
    checkRequiredDatetime(keyDate, keyTime) {
      const valueDate = this.checkRequiredString(keyDate);
      const valueTime = this.checkRequiredString(keyTime);
      if (!/^\d{4}-((0[1-9])|(1[0-2]))-((0[1-9])|([1-2][0-9])|(3[0-1]))$/.test(valueDate)) {
        throw new TypeError(`expected ${keyDate} to be a date, but found ${valueDate}`);
      }
      const momentObj = moment(valueDate + valueTime, 'YYYY-MM-DDLT');
      return momentObj.format('YYYY-MM-DD HH:mm:ss');
    },
    checkRequiredEmail(key) {
      return this.checkRequiredString(key);
    },
    checkRequiredFile(key) {
      return this.getKey(`${key}.files.0.file`, true);
    },
    checkOptionalFile(key) {
      return this.getKey(`${key}.files.0.file`, false);
    },
    checkRequiredGeslacht(key) {
      const value = this.checkRequiredString(key);
      if (!['male', 'female', 'unknown'].includes(value.toLowerCase())) {
        throw new TypeError(`expected ${key} to be male or female, but found ${value}`);
      }
      return {male: 'Man', female: 'Vrouw', unknown: 'Genderneutraal'}[value.toLowerCase()];
    },
    checkRequiredArray(key, min = 0, max = Number.MAX_SAFE_INTEGER) {
      const value = this.getKey(key, true);
      if (typeof value !== 'object' || typeof value.length !== 'number') {
        throw new TypeError(`expected ${key} to be an array, but found ${typeof value}`);
      }
      if (value.length < min) {
        throw new Error(`expected ${key} to have at least ${min} items, but found ${value.length}`);
      }
      if (value.length > max) {
        throw new Error(`expected ${key} to have at most ${max} items, but found ${value.length}`);
      }
      return value;
    },
    checkOptionalArray(key, min = 0, max = Number.MAX_SAFE_INTEGER) {
      const value = this.getKey(key, false);
      if (value === null) {
        return null;
      }
      if (typeof value !== 'object' || typeof value.length !== 'number') {
        throw new TypeError(`expected ${key} to be an array, but found ${typeof value}`);
      }
      if (value.length < min) {
        throw new Error(`expected ${key} to have at least ${min} items, but found ${value.length}`);
      }
      if (value.length > max) {
        throw new Error(`expected ${key} to have at most ${max} items, but found ${value.length}`);
      }
      return value;
    },
    checkRequiredIntArray(key, minLen = 0, maxLen = Number.MAX_SAFE_INTEGER, minVal = Number.MIN_SAFE_INTEGER, maxVal = Number.MAX_SAFE_INTEGER) {
      const value = this.checkRequiredArray(key, minLen, maxLen);
      return value.map((item, index) => this.checkRequiredInt(`${key}.${index}`, minVal, maxVal));
    },
    checkRequiredVervolgopleiding(key) {
      const value = this.checkRequiredArray(key, 1, 2);
      return value.map((item, index) => ({
        instelling: this.checkRequiredString(`${key}.${index}.instelling`),
        diploma: this.checkRequiredFile(`${key}.${index}.file`),
        datum: this.checkRequiredDate(`${key}.${index}.date`),
      }));
    },
    checkOptionalKortdurendeOpleiding(key) {
      const value = this.checkOptionalArray(key, 0, 3);
      if (!value) {
        return null;
      }
      const output = value.map((item, index) => this.checkOptionalFile(`${key}.${index}.file`));
      if (!output) {
        return null;
      }
      return output;
    },
    checkRequiredBoolean(key) {
      const value = this.getKey(key, true);
      switch (typeof value) {
        case 'boolean':
          return value;
        case 'string':
          if (['true', 'false'].includes(value)) {
            return value === 'true';
          }
        // eslint-disable-next-line no-fallthrough
        default:
          throw new TypeError(`expected ${key} to be a boolean, but found ${typeof value}`);
      }
    },
    checkRequiredExtraOpleiding(key) {
      const gevolgd = this.checkRequiredBoolean(key);
      return gevolgd ? this.checkRequiredFile(`${key}_file`) : null;
    },
    checkRequiredRbcz(key) {
      const geregistreerd = this.checkRequiredBoolean(key);
      const nvpa = this.checkRequiredBoolean(`${key}_nvpa`);
      const naam = geregistreerd ? this.checkRequiredString(`${key}_naam`) : null;
      const licentienummer = geregistreerd ? this.checkRequiredString(`${key}_licentienummer`) : null;
      const persoonlijkeAGBCode = geregistreerd ? this.checkRequiredString(`${key}_persoonlijke_agb_code`) : null;
      const praktijkAGBCode = geregistreerd ? this.checkRequiredString(`${key}_praktijk_agb_code`) : null;
      const sinds = geregistreerd ? this.checkRequiredDate(`${key}_sinds`) : null;
      return {
        geregistreerd,
        nvpa,
        naam,
        licentienummer,
        persoonlijkeAGBCode,
        praktijkAGBCode,
        sinds,
      };
    },
    checkRequiredGeschillenorganisatie(key) {
      const geregistreerd = this.checkRequiredBoolean(key);
      const naam = geregistreerd ? this.checkRequiredString(`${key}_naam`) : null;
      const licentienummer = geregistreerd ? this.checkRequiredString(`${key}_licentienummer`) : null;
      const bewijs = geregistreerd ? this.checkRequiredFile(`${key}_file`) : null;
      const scag = geregistreerd ? null : this.checkRequiredBoolean(`${key}_scag`);
      return {
        geregistreerd,
        naam,
        licentienummer,
        scag,
        bewijs,
      };
    },
    checkRequiredPraktijkgegevensArray(key) {
      const value = this.checkRequiredArray(key, 1);
      return value.map((item, index) => ({
        telefoonnummer: this.checkRequiredString(`${key}.${index}.telefoonnummer`),
        praktijk_naam: this.checkRequiredString(`${key}.${index}.praktijk_naam`),
        website: this.checkOptionalString(`${key}.${index}.website`),
        praktijk_e_mailadres: this.checkRequiredEmail(`${key}.${index}.praktijk_e_mailadres`),
        adres: this.checkRequiredString(`${key}.${index}.adres`),
        huisnummer: this.checkRequiredInt(`${key}.${index}.huisnummer`, 1),
        toevoeging: this.checkOptionalString(`${key}.${index}.toevoeging`),
        postcode: this.checkRequiredString(`${key}.${index}.postcode`),
        plaats: this.checkRequiredString(`${key}.${index}.plaats`),
        land: this.checkOptionalString(`${key}.${index}.land`),
      }));
    },
    checkData() {
      return {
        geslacht: this.checkRequiredGeslacht('geslacht'),
        voorletters: this.checkRequiredString('voorletters'),
        voornaam: this.checkRequiredString('voornaam'),
        tussenvoegsel: this.checkOptionalString('tussenvoegsel'),
        achternaam: this.checkRequiredString('achternaam'),
        geboortedatum: this.checkRequiredDate('geboortedatum'),
        geboorteplaats: this.checkRequiredString('geboorteplaats'),
        e_mailadres: this.checkRequiredEmail('e_mailadres'),
        mobiel: this.checkRequiredString('mobiel'),
        adres: this.checkRequiredString('adres'),
        huisnummer: this.checkRequiredInt('huisnummer', 1),
        toevoeging: this.checkOptionalString('toevoeging'),
        postcode: this.checkRequiredString('postcode'),
        plaats: this.checkRequiredString('plaats'),
        land: this.checkOptionalString('land'),
        cv: this.checkRequiredFile('cv'),
        basisopleiding: {
          instelling: this.checkRequiredString('basisopleiding_instelling'),
          diploma: this.checkRequiredFile('basisopleiding_file'),
          datum: this.checkRequiredDate('basisopleiding_date'),
        },
        hbo_wo_diploma: this.checkOptionalFile('hbo_wo_diploma'),
        vervolgopleiding: this.checkRequiredVervolgopleiding('vervolgopleiding'),
        kortdurende_opleiding: this.checkOptionalKortdurendeOpleiding('kortdurende_opleiding'),
        dsm: this.checkRequiredExtraOpleiding('dsm'),
        supervisie: this.checkRequiredExtraOpleiding('supervisie'),
        leertherapie: this.checkRequiredExtraOpleiding('leertherapie'),
        contracturen: this.checkRequiredInt('contracturen', 0),
        rbcz: this.checkRequiredRbcz('rbcz'),
        geschillenorganisatie: this.checkRequiredGeschillenorganisatie('geschillenorganisatie'),
        hoofdrichtingen: this.checkRequiredIntArray('hoofdrichtingen', 1, Number.MAX_SAFE_INTEGER, 1, Number.MAX_SAFE_INTEGER),
        kvk_nummer: this.checkOptionalString('kvk_nummer'),
        praktijk_naam: this.checkRequiredString('praktijkgegevens.0.praktijk_naam'),
        website: this.checkOptionalString('praktijkgegevens.0.website'),
        telefoonnummer: this.checkRequiredString('praktijkgegevens.0.telefoonnummer'),
        praktijk_e_mailadres: this.checkRequiredEmail('praktijkgegevens.0.praktijk_e_mailadres'),
        praktijkgegevens: this.checkRequiredPraktijkgegevensArray('praktijkgegevens'),
        waarom_lid_worden: this.checkRequiredInt('waarom_lid_worden', 0),
        is_maatwerkroute: this.maatwerkroute,
        ...this.maatwerkroute ? {
          motivatie: this.checkRequiredString('motivatie'),
          afspraak_1: this.checkRequiredDatetime('afspraak_date_1', 'afspraak_time_1'),
          afspraak_2: this.checkRequiredDatetime('afspraak_date_2', 'afspraak_time_2'),
          afspraak_3: this.checkRequiredDatetime('afspraak_date_3', 'afspraak_time_3'),
        } : {},
      };
    },
    sendData() {
      this.step = 6;
      this.done = false;
      const data = this.checkData();
      this.$apollo.mutate({
        mutation: inschrijven,
        variables: data,
        hasUpload: true,
      }).then(({data}) => {
        this.error = null;
        this.done = true;
        this.idealLink = data.inschrijven;
      }).catch((err) => {
        this.error = err;
        this.step = 5;
      });
    },
  },
  head: () => ({
    title: 'Lid worden',
  }),
};
